import { AxleFormName } from '@contracts/order/fields/AxleInformationFields';
import { TractorAxlesFormName } from '@contracts/order/fields/TractorInformationFields';

export const TractorAxlesFormUtils = {
  fieldName: TractorAxlesFormName,
  pathToAxles: `${TractorAxlesFormName}.${AxleFormName}`,
};
